import React, {Component} from 'react'
import { Button, Table } from 'reactstrap';
import {Link} from 'react-router-dom'
import StdButton from '../StdButton'
import { withTranslation, Trans } from "react-i18next";
import {find_evaluation, evaluation} from '../../config/evaluations'
import {Filter} from 'react-feather';
import ActionFormModal from '../StdForm/ActionFormModal'
import FilterCompaniesValidator from '../../validators/FilterCompanies'
import Switch from "react-switch";

class CompaniesTable extends Component{

    constructor(props) {
	super(props);
    }
       
  render(){
	  const {companies, filters, companies_ids, add, createCompany, include_more, selected_companies, selectCompnaies, getCompanies, issuing_companies, t} = this.props
	  
	  if(include_more === true)
	    var fields = [{name: "name", filter_type: 'text'},
                    {name: 'issuing_companies_names', filter_type: 'checkbox_list', options: issuing_companies.map(ic => ({name: ic.name, title: ic.name})) },
                    {name: "customer_id", filter_type: 'text'},
                    {name: "more", filter_type: 'checkbox_list', options: evaluation.map(e => ({name: e.letter, title: e.letter}))},
                    {name: "credit_limit", filter_type: 'range', type: 'currency'},
                    {name: "operating_revenue_or_turnover", filter_type: 'range', type: 'currency'},
                    {name: "country_iso_code", type: 'translated', filter_type: 'grouped_checkbox_list', groups: [
                      {name: 'IT', title: 'IT', options: ['IT'].map((c) => ({value: c, name: t(`country_iso_code.${c}`)})).sort(function(a,b){return a.name - b.name})},
                      {title: 'Unione Europea', name: 'EU', options: ["AL", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "LV", "LI", "LT", "LU", "MK", "MT", "MD", "ME", "NL", "NO", "PL", "PT", "RO", "RS", "SK", "SI", "ES", "SE", "GB"].map((c) => ({value: c, name: t(`country_iso_code.${c}`)})).sort((a,b) =>  {return a.name > b.name ? 1 : -1})},
                      {title: 'Extra Unione Europea', name: 'EXTRA-EU', options:["AF", "AS", "AO", "AM", "AU", "AZ", "BH", "BD", "BY", "BJ", "BW", "BR", "BF", "BI", "KH", "CM", "CA", "CV", "CF", "TD", "CL", "CN", "CO", "CD", "CI", "DJ", "EC", "EG", "GQ", "ER", "ET", "GA", "GM", "GE", "GH", "GU", "GN", "GW", "HK", "IN", "JP", "JO", "KZ", "KE", "XK", "KW", "KG", "LA", "LB", "LS", "LR", "MG", "MW", "MY", "ML", "MH", "MR", "MU", "YT", "MX", "FM", "MA", "MZ", "MM", "NA", "NP", "NZ", "NE", "NG", "MP", "OM", "PK", "PW", "PS", "PR", "QA", "RU", "RW", "RE", "SH", "ST", "SA", "SN", "SC", "SL", "SG", "SO", "ZA", "KR", "LK", "SD", "SZ", "CH", "SY", "TW", "TJ", "TZ", "TH", "TG", "TR", "TM", "UG", "UA", "AE", "US", "UZ", "VE", "VN", "VI", "EH", "YE", "ZM", "ZW"].map((c) => ({value: c, name: t(`country_iso_code.${c}`)})).sort((a,b) =>  {return a.name > b.name ? 1 : -1}) }]},
                    {name: "leftover", type: 'number', filter_type: 'range'},
                    {name: "leftover_exp", type: 'number', filter_type: 'range'},
                    {name: "dso", type: 'integer', filter_type: 'range'}]
	  else
	    var fields = [{name: "name", type: 'text'}, {name: "identification_number", type: 'text'}, {name: "address", type: 'text'}, {name: "city", type: 'text'}]
	  
	  const FiltersForm = <ActionFormModal reset_button={true} buttonProps = {{className: "content_button"}} action_text={<Filter size='15' />} trans_prefix="filter_companies"  fields={fields.map(f => ({...f, type: f.filter_type} ))} form_name="filter_companies" submitAction={(params) => {getCompanies({...params, values: {...filters, ...params.values}})}} validation={FilterCompaniesValidator}  />


	  const CellContent = ({f, company}) => {
	    if(f.name=='more')
		    return find_evaluation({score: company[f.name]}).letter
	    else if(f.type == 'number')
		    return (<Trans values={{value: company[f.name]}}>standard_formatting.number</Trans>)
	    else if(f.type == 'integer')
		    return (<Trans values={{value: company[f.name] != null ? Math.round(company[f.name]) : null}}>standard_formatting.number</Trans>) 
	    else if(f.type == 'currency')
		    return (<Trans values={{value: company[f.name]}}>standard_formatting.currency</Trans>)
      else if(f.type == 'translated')
		    return (<Trans>{f.name}.{company[f.name]}</Trans>) 
	    else if(company[f.name] != null)
		    return Array.isArray(company[f.name]) ? company[f.name].join(", ") : company[f.name]
	    else
		    return '-'
	  }

	  const SortIcon = ({name, sorted, sort_direction}) => {
	    if(name == sorted && sort_direction=='ASC')
		    return <i className="fa fa-sort-amount-down-alt"></i>
		    else if(name == sorted && sort_direction=='DESC')
		    return <i className="fa fa-sort-amount-down"></i>
		    else
		    return <i className="fa fa-sort"></i>
	  }
	  
	  const CompanyRow = ({company}) =>  {
	    return (
		    <tr>
		      {include_more === true && <td><input type="checkbox" value={company.id} checked={selected_companies.findIndex(c => c.id===company.id && (company.issuing_companies == null || company.issuing_companies.every(ic =>  c.issuing_companies.includes(ic)))) >= 0} onChange={() => selectCompnaies(company.id, company.issuing_companies)} /></td> }
		      {fields.map((f) => <td key={f.name}><CellContent f={f} company={company} /></td>)}
		      <td>
	    		  {company.id ? <Link className="btn btn-secondary" to={'/companies/'+company.id}>Scheda</Link> : <StdButton action_text='Crea' buttonAction = {() => createCompany(company)} /> }
		      </td>

		    </tr>
	    )}


	  return (<Table striped className="companies-table">
	    <thead>
		    <tr>
		      {include_more === true && <th style={{verticalAlign: 'top'}}><input type="checkbox"  checked={selected_companies.length == companies_ids.length} onChange={() => selectCompnaies(selected_companies.length == companies_ids.length)}  /></th>}
		      {fields.map((f) => <th key={f.name}>{<Trans>companies.main_info.{f.name}</Trans>}
			      {include_more === true && 
			       <React.Fragment>
			         
			         <button className="content_button" onClick={() => getCompanies({values: {...filters, sort: f.name, sort_direction: (f.name==filters.sort && filters.sort_direction==='DESC' ? 'ASC' : 'DESC')}})}>
				         <SortIcon name={f.name} sorted={filters.sort}  sort_direction={filters.sort_direction} />
			         </button>
			         
			         {FiltersForm}
			         <div className="filters">
				         {f.filter_type == 'text' && filters[f.name]}&nbsp;
				         {f.filter_type == 'range' && filters[f.name] && filters[f.name]['min'] != null && `da ${filters[f.name]['min']}`}&nbsp;
				         {f.filter_type == 'range' && filters[f.name] && filters[f.name]['max'] != null && `fino a ${filters[f.name]['max']}`}
				         {(f.filter_type == 'checkbox_list' || f.filter_type == 'grouped_checkbox_list' )&& filters[f.name] != null && Object.keys(filters[f.name]).length > 0 &&  Object.keys(filters[f.name]).map(k => k).filter(k => filters[f.name][k] === true).sort().join(", ") }
			         </div>
			       </React.Fragment>
			      }
			      
		      </th>)}
		      <th>
		      </th>
		    </tr>
	    </thead>
	    <tbody>
		    
		    {Array.isArray(companies)  && companies.length > 0 &&
		     companies.map((company) => <CompanyRow key={company.id+company.issuing_companies} company={company} /> )}
		    {Array.isArray(companies) && companies.length == 0 &&
		     <tr><th colSpan={fields.length+1}><Trans>companies.no_search_results</Trans></th></tr>
		    }
	    </tbody>
	  </Table>)

  }
}
export default withTranslation()(CompaniesTable)
